var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAdmin || _vm.isStavo || _vm.isLeiter)?_c('leiter-dashboard'):_c('div',[_c('div',{staticClass:"ma-3"},[_vm._v(" Hier werden in Zukunft Neuigkeiten angezeigt und wichtige Tools verlinkt werden ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }